import VendaEmbRefri from "components/VendaEmbRefri";

const Refrigerante = () => {
    return (

            <VendaEmbRefri />

    )
}
export default Refrigerante